export default __webpack_public_path__ + "pdf/Christian_Stolte.058df24.pdf";